import { PulseLoader } from "react-spinners";

const FallbackLoading = ({ height }) => {
  return (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{ minHeight: height ? height : "100vh" }}
    >
      <PulseLoader color="#9B1A1E" />
    </div>
  );
};

export default FallbackLoading;
